import { render, staticRenderFns } from "./buttons-agenda.vue?vue&type=template&id=5e403952"
import script from "./buttons-agenda.vue?vue&type=script&lang=ts"
export * from "./buttons-agenda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports